<template>
  <div class="schools-dash-bar">
    <div v-for="item in items" :key="item.date || item.label" class="schools-dash-bar__item">
      <div class="schools-dash-bar__track">
        <div class="schools-dash-bar__fill" :style="{ height: barHeight(item) }" />
      </div>
      <div class="schools-dash-bar__count">{{ item.count || 0 }}</div>
      <div class="schools-dash-bar__label">{{ item.label }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SchoolsDashBar',
  props: {
    items: { type: Array, default: () => [] }
  },
  computed: {
    maxCount() {
      const vals = (this.items || []).map(i => Number(i.count) || 0)
      return Math.max(...vals, 1)
    }
  },
  methods: {
    barHeight(item) {
      const count = Number(item.count) || 0
      const pct = Math.round((count / this.maxCount) * 100)
      return Math.max(pct, count > 0 ? 8 : 0) + '%'
    }
  }
}
</script>

<style scoped lang="less">
.schools-dash-bar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 6px;
  height: 120px;
  padding-top: 4px;

  &__item {
    flex: 1;
    min-width: 0;
    text-align: center;
  }

  &__track {
    height: 72px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    background: #f5f7fa;
    border-radius: 3px 3px 0 0;
    overflow: hidden;
  }

  &__fill {
    width: 100%;
    max-width: 28px;
    background: linear-gradient(180deg, #66b1ff 0%, #409eff 100%);
    border-radius: 3px 3px 0 0;
    transition: height 0.3s ease;
  }

  &__count {
    margin-top: 4px;
    font-size: 12px;
    font-weight: 600;
    color: #303133;
    line-height: 1.5;
  }

  &__label {
    margin-top: 2px;
    font-size: 12px;
    color: #909399;
    line-height: 1.5;
  }
}
</style>
